export const AI_CHAT_INPUT = 'ai-chat-input';
export const REMINDER_STORAGE_READY = 'reminder-storage-ready';
